import { motion } from "framer-motion";
import { Button } from "@heroui/react";
import { useEffect, useState } from "react";

const Hero = () => {
  const [count, setCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => (prev < 100 ? prev + 1 : 0));
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col justify-center items-center text-center text-white px-4 overflow-hidden bg-black">
      {/* 公告栏 */}
      <div className="absolute top-0 left-0 w-full bg-indigo-600 text-sm md:text-base text-white py-2 px-4 z-50 text-center shadow-md">
        <span>⚠️ 服务目前处于内测阶段，正式上线敬请期待。</span>
      </div>

      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#0f172a] via-black to-black" />

        <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#fff" strokeWidth="0.3" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="absolute w-[500px] h-[500px] bg-indigo-500/30 rounded-full blur-[200px] animate-pulse-slow top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />

        <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-indigo-400 to-transparent animate-scan opacity-30" />
        <div className="absolute top-0 left-0 h-full w-[1px] bg-gradient-to-b from-transparent via-indigo-400 to-transparent animate-scan-vertical opacity-20" />

        <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="hexagons" width="50" height="43.4" patternUnits="userSpaceOnUse" patternTransform="scale(2) rotate(0)">
                <path d="M25,0 L50,14.4 L50,38.4 L25,51.8 L0,38.4 L0,14.4 Z" fill="none" stroke="#4f46e5" strokeWidth="0.5" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#hexagons)" />
          </svg>
        </div>

        <div className="absolute inset-0 overflow-hidden opacity-10">
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="absolute h-[1px] bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-data-flow"
              style={{
                top: `${Math.random() * 100}%`,
                left: "-10%",
                width: `${30 + Math.random() * 70}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 7}s`,
              }}
            />
          ))}
        </div>
      </div>

      <motion.h1
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-5xl md:text-6xl font-extrabold tracking-tight z-10 leading-tight bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-400 bg-clip-text text-transparent drop-shadow-[0_0_8px_rgba(129,140,248,0.5)] mt-12"
      >
        Seton DNS
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="mt-6 text-lg md:text-xl text-slate-300 max-w-2xl z-10 leading-relaxed"
      >
        极速 · 稳定 · 安全的企业级智能 DNS 服务，支持全球加速、DDoS 防护、智能调度、海外拦截等多场景接入。
      </motion.p>

      <motion.div
        className="mt-10 flex gap-4 flex-wrap justify-center z-10"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.6 }}
      >
        <Button
          color="primary"
          radius="full"
          size="lg"
          className="px-6 shadow-lg hover:shadow-indigo-400/30 ring-1 ring-white/20 relative overflow-hidden group transition-all duration-300 hover:scale-105"
          onClick={() => setIsModalOpen(true)}
        >
          <span className="relative z-10">立即接入</span>
          <span className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
        </Button>

        <Button
          as="a"
          href="https://status.setondns.com"
          target="_blank"
          variant="light"
          radius="full"
          size="lg"
          className="px-6 text-white/80 border border-white/20 hover:border-white backdrop-blur-sm relative overflow-hidden group transition-all duration-300 hover:scale-105"
        >
          <span className="relative z-10">系统状态</span>
          <span className="absolute inset-0 bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
        </Button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="animate-bounce cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-white/60 hover:text-white transition-colors"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </motion.div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-[#0f172a] text-white rounded-2xl p-8 max-w-sm w-full shadow-xl relative">
            <h2 className="text-xl font-bold mb-4">温馨提示</h2>
            <p className="text-slate-300 leading-relaxed">
              目前服务正在内测中，敬请期待。
            </p>
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-6 inline-flex items-center justify-center px-4 py-2 rounded-full bg-indigo-600 hover:bg-indigo-500 transition text-white shadow-md w-full"
            >
              确定
            </button>
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-3 right-3 text-slate-400 hover:text-slate-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes scan {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-scan {
          animation: scan 5s linear infinite;
        }

        @keyframes scan-vertical {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
        .animate-scan-vertical {
          animation: scan-vertical 7s linear infinite;
        }

        @keyframes pulse-slow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.1);
          }
        }
        .animate-pulse-slow {
          animation: pulse-slow 6s ease-in-out infinite;
        }

        @keyframes data-flow {
          0% { transform: translateX(0); opacity: 0; }
          50% { opacity: 1; }
          100% { transform: translateX(200%); opacity: 0; }
        }
        .animate-data-flow {
          animation: data-flow 8s linear infinite;
        }

        @media (max-width: 768px) {
          .animate-scan,
          .animate-scan-vertical,
          .animate-data-flow {
            animation: none;
            opacity: 0.1;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;